import { useContext } from 'react';
import { Link } from 'react-navi';
import QRCode from 'react-qr-code';
import { MobileAppContext } from 'contexts/mobileApp';

import iosApp from 'assets/images/mobileApp/downloadIOS.webp';

interface DownloadIOSAppProps {
  onClick?: () => void;
  withQRCode?: boolean;
}

export const DownloadIOSApp = ({
  onClick,
  withQRCode = false,
}: DownloadIOSAppProps) => {
  const { data } = useContext(MobileAppContext);

  if (!data) return null;
  const { iosLink } = data;

  return (
    <>
      {withQRCode && iosLink && (
        <Link
          href={iosLink}
          target="_blank"
          className="qrcode-container"
          onClick={onClick}
        >
          <QRCode className="qrcode" size={176} value={iosLink} />
        </Link>
      )}
      {iosLink && (
        <Link
          href={iosLink}
          target="_blank"
          className="button"
          onClick={onClick}
        >
          <img
            src={iosApp}
            width={144}
            height={48}
            alt="App Store link"
            className="button-download"
          />
        </Link>
      )}
    </>
  );
};
